import analytics from './analytics';

// @types/segment-analytics (0.0.38, latest — DT package is unmaintained) does
// not declare addSourceMiddleware. Augment the namespace and export the
// middleware shape so callers don't have to re-derive it.

interface SegmentEvent {
  type: string;
  event?: string;
  properties?: Record<string, unknown>;
  context?: {
    page?: {
      path?: string;
      referrer?: string;
      search?: string;
      title?: string;
      url?: string;
    };
    [key: string]: unknown;
  };
  [key: string]: unknown;
}

interface SegmentSourceMiddlewarePayload {
  obj: SegmentEvent;
}

export interface SegmentSourceMiddlewareData {
  payload: SegmentSourceMiddlewarePayload;
  integrations: Record<string, unknown>;
  next: (payload: SegmentSourceMiddlewarePayload) => void;
}

export type SegmentSourceMiddleware = (
  data: SegmentSourceMiddlewareData
) => void;

declare global {
  namespace SegmentAnalytics {
    interface AnalyticsJS {
      addSourceMiddleware(middleware: SegmentSourceMiddleware): void;
    }
  }
}

function addSourceMiddleware(middleware: SegmentSourceMiddleware): void {
  return analytics().addSourceMiddleware(middleware);
}

export default addSourceMiddleware;
